import Projects from "../../components/Project/Projects";

export default function AdminContracts() {
  return (
    <Projects userRole={"Admin"} viewType={"contracts"} />
  );
}
